module.exports = __webpack_public_path__ + "static/media/nect-logo-black.0a621f25.svg";